import { useMemo, useRef } from 'react';

export const useMountedTableTabs = <Tab extends string>(activeTab: Tab): ReadonlySet<Tab> => {
  const mountedTabsRef = useRef<ReadonlySet<Tab>>(new Set());

  return useMemo(() => {
    if (mountedTabsRef.current.has(activeTab)) {
      return mountedTabsRef.current;
    }

    const nextMountedTabs = new Set(mountedTabsRef.current);
    nextMountedTabs.add(activeTab);
    mountedTabsRef.current = nextMountedTabs;
    return nextMountedTabs;
  }, [activeTab]);
};
